import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { GlobalLoading } from "../components/GlobalLoading";

// Guard for authenticated routes.
// Optionally accepts allowedRoles — when omitted, any authenticated user passes.
// When passed, role must match. Non-matching roles redirect to /.
export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) return <GlobalLoading />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

// Convenience wrapper for public-only routes (redirect authenticated away).
// Example: /login should redirect logged-in users to /dashboard.
export const PublicOnlyRoute = ({ children, redirectTo = "/dashboard" }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <GlobalLoading />;
  if (user) return <Navigate to={redirectTo} replace />;
  return children;
};
